import { useSelector } from 'react-redux';
import { isAppModule } from '@utils/constants';
import { checkFeature } from '@utils/platform/features/checkFeature';
import {
  appLiveModeOnTrendsSelector,
  realTimeOnTrendsFeatureSelector,
} from '@store/common/selectors';
import { hasAiAlertSelector } from '@store/trends/aiAlerts/selectors';
import { hasManualAlertSelector } from '@store/trends/alerts/selectors';
import { compareOnTrendsModeSelector } from '@store/trends/base/selectors';

function useShowLiveMode() {
  // TODO: in such scenarios where it means the same thing but only the state key is different
  // make the change in the selector to switch state keys based on app
  // so that rest of the code doesn't have to change
  const isLiveModeOnTrendsEnabled = useSelector(realTimeOnTrendsFeatureSelector);
  const isAppLiveModeOnTrendsEnabled = useSelector(appLiveModeOnTrendsSelector);

  // disable live mode on alert diagnostics view
  const hasAiAlert = useSelector(hasAiAlertSelector);
  const hasManualAlert = useSelector(hasManualAlertSelector);
  const hasAlert = hasAiAlert || hasManualAlert;
  const compareMode = useSelector(compareOnTrendsModeSelector);

  return checkFeature(
    'trends.base.live-mode',
    !compareMode && (isAppModule ? isAppLiveModeOnTrendsEnabled : isLiveModeOnTrendsEnabled),
  );
}

export default useShowLiveMode;
